import { siteInfo } from '@/mocks/home';

const footerNavGroups = [
  {
    title: '热门板块',
    links: [
      { label: '焦点专题', href: '#carousel' },
      { label: '关于我们', href: '#about' },
      { label: '吃瓜视频', href: '#media' },
      { label: '最新动态', href: '#updates' },
      { label: '投稿联系', href: '#contact' },
    ],
  },
  {
    title: '内容分类',
    links: [
      { label: '塌房实录', href: '#index' },
      { label: '爆料专区', href: '#index' },
      { label: '明星八卦', href: '#index' },
      { label: '直播翻车', href: '#index' },
    ],
  },
  {
    title: '合作伙伴',
    links: [],
  },
];

export default function Footer() {
  const handleScroll = (href: string) => {
    const el = document.querySelector(href);
    if (el) {
      el.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <footer id="footer" className="w-full bg-foreground-900 text-background-50/70">
      <div className="max-w-[1200px] mx-auto px-4 md:px-6 py-14 md:py-16">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-10">
          <div className="lg:col-span-1">
            <span className="font-heading text-xl text-background-50 mb-4 block">
              {siteInfo.name}
            </span>
            <p className="text-sm leading-relaxed mb-5">
              专注黑料吃瓜内容聚合，汇聚海量网红黑料吃瓜视频、17黑料吃瓜网最新爆料与吃瓜黑料在线资源，每日更新热门黑料吃瓜动态，一站式满足用户吃瓜需求。
            </p>
            <div className="flex items-center gap-3">
              <span className="w-8 h-8 rounded-lg bg-background-50/10 flex items-center justify-center cursor-pointer hover:bg-background-50/20 transition-colors">
                <i className="ri-weibo-line text-sm"></i>
              </span>
              <span className="w-8 h-8 rounded-lg bg-background-50/10 flex items-center justify-center cursor-pointer hover:bg-background-50/20 transition-colors">
                <i className="ri-wechat-line text-sm"></i>
              </span>
              <span className="w-8 h-8 rounded-lg bg-background-50/10 flex items-center justify-center cursor-pointer hover:bg-background-50/20 transition-colors">
                <i className="ri-tiktok-line text-sm"></i>
              </span>
            </div>
          </div>

          {footerNavGroups.map((group) => (
            <div key={group.title}>
              <h4 className="font-heading text-sm text-background-50 mb-4">{group.title}</h4>
              {group.links.length > 0 ? (
                <ul className="space-y-2.5">
                  {group.links.map((link) => (
                    <li key={link.label}>
                      <a
                        href={link.href}
                        onClick={(e) => {
                          e.preventDefault();
                          handleScroll(link.href);
                        }}
                        className="text-sm hover:text-background-50 transition-colors cursor-pointer"
                      >
                        {link.label}
                      </a>
                    </li>
                  ))}
                </ul>
              ) : (
                <p className="text-sm text-background-50/40">诚邀优质站点合作</p>
              )}
            </div>
          ))}
        </div>

        <div className="border-t border-background-50/10 mt-12 pt-8 flex flex-col sm:flex-row items-center justify-between gap-3">
          <p className="text-xs text-background-50/40">
            &copy; {new Date().getFullYear()} {siteInfo.name} 版权所有
          </p>
          <div className="flex items-center gap-4 text-xs text-background-50/40">
            <span className="cursor-pointer hover:text-background-50/60 transition-colors">用户协议</span>
            <span className="cursor-pointer hover:text-background-50/60 transition-colors">隐私政策</span>
            <span className="cursor-pointer hover:text-background-50/60 transition-colors">免责声明</span>
          </div>
        </div>
      </div>
    </footer>
  );
}